import React from "react";
import { useI18n } from "@/lib/i18n";
import { PhotoTile, GridQuotaBar } from "@/components/gallery/PhotoGridParts";

/**
 * Step 01 — one grid for everything. The first `edit_quota` picks are included;
 * anything after that is flagged as a priced extra right on the tile.
 */
export const PhotoGrid = ({ data, edits, extras, baseCount, maxTotal, extraPrice,
  onZoom, onToggleSelect, onShowHelp, onSelectRemaining, onUnselectAll }) => {
  const { t } = useI18n();
  const quota = data.edit_quota;
  const quotaFull = baseCount >= quota;
  const totalPicked = Object.keys(edits).length;
  const canCharge = quotaFull && data.allow_extra_edits && totalPicked < maxTotal;

  return (
    <>
      <p className="eyebrow mb-4">{t("step_select")}</p>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-medium">{t("choose_edits")}</h1>
      <p className="mt-4 text-sm sm:text-base text-[#A8A8A8] max-w-xl leading-relaxed">
        {t("choose_edits_body", { n: quota })}
      </p>

      <GridQuotaBar data={data} quota={quota} quotaFull={quotaFull} baseCount={baseCount}
        totalPicked={totalPicked} maxTotal={maxTotal} extraPrice={extraPrice}
        onSelectRemaining={onSelectRemaining} onUnselectAll={onUnselectAll} />

      <p className="mt-4 text-xs text-[#707070] hidden sm:block" data-testid="inspect-hint">{t("click_to_inspect")}</p>
      <button data-testid="show-help-btn" onClick={onShowHelp}
        className="mt-3 inline-flex items-center min-h-[44px] text-[10px] tracking-[0.18em] uppercase text-[#D4AF37] hover:underline">
        {t("ob_eyebrow")}
      </button>

      {data.photos.length === 0 ? (
        <p data-testid="no-photos-message" className="mt-12 border border-[#2A2A2A] bg-[#0B0B0B] p-12 text-center text-sm text-[#A8A8A8]">
          {t("gallery_preparing")}
        </p>
      ) : (
        <div className="mt-10 columns-2 sm:columns-3 lg:columns-4 xl:columns-5 gap-4" data-testid="photo-masonry-grid">
          {data.photos.map((photo) => {
            const selected = photo.file_id in edits;
            return (
              <PhotoTile key={photo.file_id} photo={photo} selected={selected}
                isExtra={extras.includes(photo.file_id)}
                wouldCharge={!selected && canCharge} extraPrice={extraPrice}
                onZoom={onZoom} onToggleSelect={onToggleSelect} />
            );
          })}
        </div>
      )}
    </>
  );
};
